import { ConditionBase, ConditionBuilder } from '../condition.type';

export interface ConditionBlank extends ConditionBase {
  /**
   * The value of the related field must have the same blank-state,
   * as the boolean condition.
   */
  blank: boolean;
}

/**
 * Type guard that checks if an object fulfills the `ConditionBlank` interface
 *
 * @param c Non nullish object
 * @returns `true` if `c` satisfies `ConditionBlank`
 */
export const isConditionBlank = (c: Record<string, any>): c is ConditionBlank =>
  'blank' in c;

/**
 * @param condition Condition object
 *
 * @returns
 * A condition function that returns `true` if the value
 * has the same blank-state as the condition.
 *
 * @example
 * blank({blank: true})('') // true
 * blank({blank: true})('test') // false
 * blank({blank: true})([]) // true
 * blank({blank: true})([1]) // false
 */
export const blank: ConditionBuilder<ConditionBlank, any> =
  (condition) => (value) =>
    isEmpty(value) === condition.blank;

function isEmpty(value: unknown): boolean {
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  return value === undefined || value === null || value === '';
}
